
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QMonthDialog extends Serenity.EntityDialog<QMonthRow, any> {
        protected getFormKey() { return QMonthForm.formKey; }
        protected getIdProperty() { return QMonthRow.idProperty; }
        protected getLocalTextPrefix() { return QMonthRow.localTextPrefix; }
        protected getNameProperty() { return QMonthRow.nameProperty; }
        protected getService() { return QMonthService.baseUrl; }
        protected getDeletePermission() { return QMonthRow.deletePermission; }
        protected getInsertPermission() { return QMonthRow.insertPermission; }
        protected getUpdatePermission() { return QMonthRow.updatePermission; }

        protected form = new QMonthForm(this.idPrefix);

    }
}